// biome-ignore-all lint/suspicious/noExplicitAny: generic constraints mirror create-action.ts's ported redux-toolkit PrepareAction<any> dispatch pattern
import { actionSuffixDivider, createAction } from './create-action.js';
import { isActionWithSuffix, isCompleteAction, isFailureAction, isRequestAction, isSuccessAction, } from './predicates.js';
/**
 * Creates the runtime async action implementation shared by the overloads above.
 *
 * @param type - The base action type string.
 * @param request - A prepare function for the request action payload.
 * @param success - A prepare function for the success action payload.
 * @param failure - An optional prepare function for the failure action payload.
 * @returns An action creator with request, success, and optional failure actions.
 */
export function createAsyncAction(type, request, success, failure) {
    const action = createAction([type, 'request'].join(actionSuffixDivider), request);
    // Attach the success action only when the caller supplied its prepare function.
    if (success) {
        // Add the success action while preserving the request creator's identity.
        Object.assign(action, {
            success: createAction([type, 'success'].join(actionSuffixDivider), success),
        });
    }
    // Attach the failure action only for async workflows that support failure results.
    if (failure) {
        // Add the failure action alongside the existing request and success actions.
        Object.assign(action, {
            failure: createAction([type, 'failure'].join(actionSuffixDivider), failure),
        });
    }
    // `action` is progressively mutated with `success`/`failure` properties above, so its static
    // type can't reflect the final shape declared by this function's overload signatures.
    return action;
}
export { isActionWithSuffix, isCompleteAction, isFailureAction, isRequestAction, isSuccessAction };
//# sourceMappingURL=create-async-action.js.map